import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import BaseLink from "~/components/links/BaseLink";

import transition from "~/utilities/transition";
import { sanitizeAndParseHTML } from "~/utilities/helpers";

const Columns = styled.div`
    columns: ${({ numberOfColumns }) =>
        numberOfColumns ? numberOfColumns : 4};
    column-gap: ${({ theme }) => theme.layout.largeGutter};
`;

const Col = styled.div`
    display: flex;
    flex-direction: column;
    break-inside: avoid-column;
    overflow: hidden;
`;

const MainNavLink = styled(BaseLink)`
    ${transition({}, "color")};
    font-weight: 900;
    font-size: 2.3rem;
    color: ${({ theme }) => theme.palette.darkBlue};
    margin-bottom: 10px;

    &:hover,
    &:focus {
        color: ${({ theme }) => theme.palette.lightBlue};
    }
`;

const SubNavLink = styled(BaseLink)`
    ${transition({}, "border-bottom")};
    font-size: 1.8rem;
    color: ${({ theme }) => theme.palette.black};
    position: relative;

    &:hover,
    &:focus {
        text-decoration: underline;
    }
`;

const Ul = styled.ul`
    margin-bottom: 30px;
`;

const Li = styled.li`
    margin-bottom: 10px;
`;

const SubNavLinks = ({
    links = [],
    numberOfColumns,
    tagLabel = null,
    tagRef = null,
}) => (
    <Columns {...{ numberOfColumns }}>
        {links.map(({ linkLabel, linkUrl, subNavigation }, index) => (
            <Col key={`${index}-${linkLabel}`}>
                {linkLabel && linkUrl ? (
                    <MainNavLink
                        to={linkUrl}
                        tagRef={tagRef}
                        tagLabel={tagLabel}
                    >
                        {sanitizeAndParseHTML(linkLabel)}
                    </MainNavLink>
                ) : null}
                {subNavigation?.length ? (
                    <Ul>
                        {subNavigation.map(({ linkLabel, linkUrl }, index) => (
                            <Li key={`${index}-${linkLabel}`}>
                                <SubNavLink
                                    to={linkUrl}
                                    tagRef={tagRef}
                                    navIndex={index}
                                    tagLabel={tagLabel}
                                    isSubNav={true}
                                >
                                    {sanitizeAndParseHTML(linkLabel)}
                                </SubNavLink>
                            </Li>
                        ))}
                    </Ul>
                ) : null}
            </Col>
        ))}
    </Columns>
);

SubNavLinks.propTypes = {
    numberOfColumns: PropTypes.number.isRequired,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            linkLabel: PropTypes.string.isRequired,
            linkUrl: PropTypes.string.isRequired,
            subNavigation: PropTypes.arrayOf(
                PropTypes.shape({
                    linkUrl: PropTypes.string.isRequired,
                    linkLabel: PropTypes.string.isRequired,
                }),
            ),
        }),
    ).isRequired,
    tagLabel: PropTypes.string,
    tagRef: PropTypes.object,
};

export default SubNavLinks;
